import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CategoryMenu, Icon } from './MarketShell';
import { SERVICES } from '../../lib/marketServices';

// The phone's bottom navigation on market pages (owner, 2026-11-02):
// الرئيسية · الأقسام · طلباتي · الرسائل · حسابي — for everyone, guests too
// (a guest is sent to sign in, and comes back). It replaces the trader bottom
// nav on market pages, so there is never two. Hidden where a page has its own
// sticky bar (the product page) and in checkout. Phone width only (market.css).

const T = {
  ar: { home: 'الرئيسية', cats: 'الأقسام', orders: 'طلباتي', messages: 'الرسائل', account: 'حسابي',
    purchases: 'مشترياتي من المتجر', quotes: 'طلبات التسعير', newReq: 'طلب جديد', close: 'إغلاق' },
  en: { home: 'Home', cats: 'Categories', orders: 'My orders', messages: 'Messages', account: 'Account',
    purchases: 'My store purchases', quotes: 'Quote requests', newReq: 'New request', close: 'Close' },
};
T.zh = T.en;

const HIDE = [/^\/market\/checkout/, /^\/market\/[0-9a-f]{8}-[0-9a-f]{4}-/i];
export const bottomNavHidden = (path) => HIDE.some((re) => re.test(path || ''));

export default function MarketBottomNav({ lang = 'ar', user, home = '/' }) {
  const nav = useNavigate();
  const loc = useLocation();
  const c = T[lang] || T.ar;
  const [cats, setCats] = useState(false);
  // «طلباتي» holds everything the trader bar had under it: store purchases, quote requests, a new request
  const [orders, setOrders] = useState(false);
  if (bottomNavHidden(loc.pathname)) return null;
  const signedIn = (to) => (user ? to : `/login?next=${encodeURIComponent(to)}`);
  const items = [
    ['home', home, <Icon.Home key="h" />, loc.pathname === home || loc.pathname === '/market'],
    ['cats', null, <Icon.Grid key="g" />, cats || loc.pathname.startsWith('/market/c/') || loc.pathname === '/market/products'],
    ['orders', null, <Icon.Orders key="o" />, orders || loc.pathname.startsWith('/market/orders')],
    ['messages', signedIn('/inbox'), <Icon.Chat key="m" />, loc.pathname.startsWith('/inbox')],
    // signed out: sign in and come back to this page (store test 2026-11-03)
    ['account', user ? '/dashboard' : `/login?next=${encodeURIComponent(loc.pathname + loc.search)}`, <Icon.User key="u" />, loc.pathname.startsWith('/dashboard')],
  ];
  return (
    <>
      {/* a div, never <nav>: index.css styles every <nav> as the site's top bar */}
      <div className="mk-bnav" role="navigation" data-bottom-nav="1" aria-label={c.home} dir={lang === 'ar' ? 'rtl' : 'ltr'}>
        {items.map(([key, to, icon, on]) => (
          <button key={key} type="button" className={on ? 'on' : ''} aria-current={on ? 'page' : undefined} data-bnav={key}
            onClick={() => (to ? nav(to) : key === 'cats' ? (setOrders(false), setCats((x) => !x)) : (setCats(false), setOrders((x) => !x)))}>
            {icon}<span>{c[key]}</span>
          </button>
        ))}
      </div>
      {cats && <CategoryMenu lang={lang} onClose={() => setCats(false)} />}
      {orders && (
        <div className="mk-sheet-back mk-bnav-sheet" data-orders-sheet="1" onClick={() => setOrders(false)}>
          <div className="mk-sheet" role="dialog" aria-label={c.orders} onClick={(e) => e.stopPropagation()}>
            <div className="mk-sheet-head"><b>{c.orders}</b><button type="button" className="mk-sheet-x" aria-label={c.close} onClick={() => setOrders(false)}>×</button></div>
            <button type="button" className="mk-svc-row" data-orders-go="purchases" onClick={() => { setOrders(false); nav(signedIn('/market/orders')); }}><span><b>{c.purchases}</b></span></button>
            <button type="button" className="mk-svc-row" data-orders-go="quotes" onClick={() => { setOrders(false); nav(signedIn('/dashboard?tab=requests')); }}><span><b>{c.quotes}</b></span></button>
            <p className="mk-bnav-sub">{c.newReq}</p>
            {SERVICES.map((sv) => (
              <button key={sv.key} type="button" className="mk-svc-row" data-orders-new={sv.key} onClick={() => { setOrders(false); sv.go(nav); }}><span><b>{sv[lang] || sv.ar}</b></span></button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
